<template lang="pug">
AppDropdown(
  :class="dropdownClass"
  :direction="direction"
  trigger-classes="btn btn-naked"
)
  template(#trigger)
    .d-flex.align-items-center.dropdown-toggle.btn(
      ref="trigger"
      v-tooltip="tooltipOptions"
      :class="triggerClasses"
      data-toggle="dropdown"
      :data-original-title="title"
    )
      span
        | {{ showDescription ? active.description : active.abbr }}
      i.hi.hi-caret.hi-10.ml-5
  li.app-column-toggle(
    v-for="(option, index) in options"
    :key="index"
  )
    a(@click="onClick(option)")
      .row
        .col-xs-12.text-lighter
          | {{ option.description }}
      .row.align-items-center
        .col-xs-12.d-flex.align-items-center.justify-content-between
          p.m-0
            template(v-if="option.offset")
              | ({{ option.offset }})
            |  {{ option.display_name }}
          i.hi.hi-check.text-blue.ml-10(v-if="isSelected(option)")
</template>
<script>
export default {
  name: 'AppTimeZoneDropdown',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // ActiveTimeZone object
    active: {
      type: Object,
      default: () => ({}),
    },
    direction: {
      type: String,
      default: 'left',
    },
    options: {
      type: Array,
      default: () => [],
    },
    tooltipOptions: {
      type: Object,
      default: () => ({}),
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
    triggerClasses: {
      type: String,
      default: '',
    },
  },
  emits: ['input'],
  computed: {
    dropdownClass() {
      return {
        disabled: this.disabled,
        'vue-app-time-zone-dropdown': true,
      };
    },
    title() {
      return this.active.offset ? `(${this.active.offset}) ${this.active.display_name}` : this.active.display_name;
    },
  },
  methods: {
    isSelected(option) {
      // Two rows can share a zone, so match on mode when there is one.
      if (option.mode && this.active.mode) {return option.mode === this.active.mode;}

      return option.for === this.active.for;
    },
    onClick(option) {
      if (!this.disabled) {
        this.$emit('input', option.for, option.description, option.mode);
        // Picking a zone reloads the page's widgets, and that reactive re-render can run
        // synchronously inside this click - ahead of Bootstrap's own document click listener that
        // would otherwise close the dropdown, leaving it (and its .show "pressed" look) stuck open.
        window.bootstrap?.Dropdown?.getInstance(this.$refs.trigger)?.hide();
      }
    },
  },
};
</script>
